import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { merge, Subscription } from 'rxjs';
import { InitializerService } from '../../services/initializer.service';
import { CartService } from '../../services/cart.service';
import { filter, tap } from 'rxjs/operators';
import { TagManagerService } from '../../services/tag-manager.service';

@Component({
  selector: 'my-portal-btn-whats-app',
  templateUrl: './btn-whats-app.component.html',
  styleUrls: ['./btn-whats-app.component.scss']
})
export class BtnWhatsAppComponent implements OnInit,OnDestroy {
    private whatsAppInfoSubscription$!: Subscription;
    private positionHandlerSubscription$!: Subscription;

    @Input() infoData : any
    isMobile: boolean = this.initializerService.isMobileDevice();
    whatsAppNumber: string = '';
    whatsAppMessage: string = '';
    private initialPosition: 'right' | 'left' = 'right';
    private currentDataCart: any;

    constructor(private router: Router, private initializerService: InitializerService, private readonly cartService: CartService, private readonly tagManagerService: TagManagerService) {}

    ngOnInit(): void {
        this.initialPosition = this.infoData.whatsapp.position.position;

        if (this.isMobile) {
            this.positionHandlerSubscription$ = merge(this.cartService.currentDataCartItems.pipe(tap(cartValue => this.currentDataCart = cartValue)), this.router.events.pipe(filter((event: Event) => event instanceof NavigationEnd))).subscribe((values: any) => {
                if (this.currentDataCart.count) {
                    if (values instanceof NavigationEnd && values.url !== '/sale') {
                        this.infoData.whatsapp.position.position = 'left';
                    }

                    if (!(values instanceof NavigationEnd)) {
                        this.infoData.whatsapp.position.position = 'left';
                    }
                } else {
                    this.infoData.whatsapp.position.position = this.initialPosition;
                }

                if (this.router.url === '/sale') {
                    this.infoData.whatsapp.position.position = 'right';
                }

            });
        }


       this.handleWhatsApp();

        this.whatsAppInfoSubscription$ = this.initializerService.currentWhatsAppInfo.subscribe((whatsAppInfo: any) => {
                this.handleWhatsApp(whatsAppInfo);
        })
    }

    handleWhatsApp(genericPageWhatsApp?: any): void {
        const data = genericPageWhatsApp || this.infoData.whatsapp.whatsapp_info;

        if (!data.number) {
            data.number = '';
        }

        this.whatsAppMessage = data.message;
        let whats = data.number.replace(/\D+/g, '').replace(/^0+/, '');
        let hasCountryCode = whats.substring(0, 4).includes('+55');

        if(!hasCountryCode && this.infoData.whatsapp.whatsapp_info.number.length <= 11){
            const newWhats = `55${this.infoData.whatsapp.whatsapp_info.number}`
            whats = newWhats;
        }
        data.number = whats;
        this.whatsAppNumber = data.number;

        if (data.number.length <= 11) {
            const newWhats = data.number;
            data.number = newWhats;
            this.whatsAppNumber = data.number;
        }
    }

    triggerWhatsAppEvent(): void {
        this.tagManagerService.whatsAppEvent();
    }

    ngOnDestroy(): void {
        if (this.whatsAppInfoSubscription$) {
            this.whatsAppInfoSubscription$.unsubscribe();
        }

        if (this.positionHandlerSubscription$) {
            this.positionHandlerSubscription$.unsubscribe();
        }
    }
}
